// import * as TYPES from './_store/types';
import { usePageStore } from '@/store';

// const agentId = 0;

// async function getAgentInfo() {
//     return this.axiosIns
//         .post('/api-graphql', {
//             query: `{agent(id:${agentId}){fullName,phone,email,externalUrl}}`
//         })
//         .then(res => {
//             return res.data;
//         })
//         .catch(errorInfo => {
//             console.log(errorInfo);
//         });
// }

// async function getCompanyInfo() {
//     return this.axiosIns
//         .post('/api-graphql', {
//             query: `{company{address}}`
//         })
//         .then(({ data }) => {
//             return data;
//         })
//         .catch(errorInfo => {
//             console.log(errorInfo);
//         });
// }

export async function asyncData(store) {
    let pageStore = usePageStore(this.$pinia);
    let ps = []
    if (!this.agentDetail) {
        ps.push(pageStore.getAgentInfo(this.agentId))
    }
    if (!this.agentAddress) {
        ps.push(pageStore.getCompanyInfo())
    }
    return Promise.all(ps)
}
